"use client";

import type { FC } from "react";
import { SCORE_INTRO_COPY } from "../onboardingWizardCopy";

const LEGEND_ROWS = SCORE_INTRO_COPY.legend;

export const FitnessScoreLegendCard: FC = () => (
  <div
    className="w-full rounded-3 bg-background_solid_neutral_primary p-4"
    data-testid="fitness-score-legend-card"
    data-figma-node="97267:70518"
  >
    <div className="flex flex-col gap-2">
      {LEGEND_ROWS.map((row) => (
        <div key={row.title} className="flex items-start gap-2">
          <span
            className={`mt-0.5 size-[11px] shrink-0 rounded-full ${row.dotClass}`}
            aria-hidden
          />
          <div className="flex min-w-0 flex-col">
            <p className="body_bold_m text-content_primary">{row.title}</p>
            <p className="body_s text-content_tertiary">{row.body}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);
